<!--
  Spaltenraster für Feldzeilen, reicht die Spaltenzahl per provide an die Zeilen weiter
-->
<template>
  <div class="sidebar-field-grid" :style="gridStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SidebarFieldGrid',
  props: {
    columns: { type: Number, default: 2 },
  },
  provide() {
    // Die Zeile braucht die Spaltenzahl, um die Trennlinie der letzten Spalte weglassen zu können
    return { sidebarFieldColumns: () => this.columns };
  },
  computed: {
    gridStyle() {
      return { gridTemplateColumns: `repeat(${this.columns}, minmax(0, 1fr))` };
    },
  },
};
</script>

<style scoped>
.sidebar-field-grid {
  display: grid;
}
</style>
